/* eslint-disable max-lines */
/* eslint-disable max-statements */
import {useState, useEffect, useRef, useCallback} from 'react';
import * as store from '@/store';
import Tree from '@baidu/rc-tree';
import '@baidu/rc-tree/assets/index.css';
import {DOC_TYPE, BOOK_TYPE} from '@/constants/document/doc';
import {PageScope, InheritRepo} from '@/Constant';
import sdk from '@/sdk';
import {feLogger, docMove} from '@/buried';
import {useHistory, useParams} from 'react-router-dom';
import CustomNode from './CustomNode';
import {
    getTreeNodeListData,
    getTreeNodeData,
    getNodeById,
    getNodesByIds,
    getChildNodesDataById,
    getDocumentInfo,
    getDocuments,
    updateChildNodes,
    updateChildNodesAfterDel,
    getNextNode,
    getPreNode,
    delTreeNodeByDrag,
    addTreeNodeByDrag,
    isSameArr,
    getBookDirData,
    getPosterityNodes,
} from '@/domains/space/Repository/SidebarNew/sidebarTreeUtils';
import {
    canEditInKnowledge,
    createHomeUrl,
    isPersonalMyself,
    isPrivateAndNoPower,
    isRestrictedAndNoPower,
} from '@/domains/space/Repository/knowledgeUtils';
import {TreeNodeData} from '@/domains/space/Repository/SidebarNew/type';
import {
    PathParams, Repository, WizDocument, User,
    DocumentOperateData, DocumentOperateType, DocumentUpdateData, Department, DocumentUpdateOperation,
} from '@/interface';
import kuPiper, {KuPiper} from '@/middleware/kuPiper';
import routers, {buildPath} from '@/config/routers';
import NodeIcon from '@/domains/space/Repository/SidebarNew/components/NodeIcon';

import treeNodeArrowSvg from '@/assets/svg/treeNodeArrow.svg';
import treeNodeArrowSelectedSvg from '@/assets/svg/treeNodeArrowSelected.svg';

import SidebarAddMenu from '../components/SidebarAddMenu';
import SidebarMoreMenu from '../components/SidebarMoreMenu';
import SidebarDragDialog from '../components/SidebarDragDialog';
import {useIntl} from 'react-intl';
import {setDocumentTitle, openInSystemBrowser} from '@/utils/browserUtils';
import {getDocsInMeeting} from '@/utils/document/meetingMode';
import {useRepositoryContext} from '@/pages/Repository/context';
import KuAuthority from '@/auth/KuAuthority';
import toast, {toastObjects, ToastType} from '@/components/Toast';
import Icon, {IconSize} from '@/components/Icon';
import LoadSvg from '@/icons/LoadingSvg';
import {CloseSvg} from '@/icons/index';
import classNames from 'classnames';
import styles from './SidebarTree.module.scss';
import {isMac} from '@/utils/commonUtils';
import BatchTool from '../../components/BatchTool';
import {useTreeBatchOperate} from '../hooks/useTreeBatchOperate';
import {WizKnownError} from '@/sdk/common/error';

function getIcon(item: any) {
    const {type, scope, inheritRepo} = item;
    const isPagePublicRead = scope === PageScope.PagePublic;
    const isPagePublicEdit = scope === PageScope.PagePublicEdit;
    const isPagePublic = isPagePublicRead || isPagePublicEdit;
    const isInTeam = item.type === DOC_TYPE.DIRECTORY;
    const isNotInheritRepo = isInTeam && inheritRepo === InheritRepo.Not_Inherit;
    const isInMeeting = item.isMeeting;
    const isBook = type === DOC_TYPE.DIRECTORY;
    const isSheet = type === DOC_TYPE.SHEET;
    const isPPT = type === DOC_TYPE.PPT;
    const isDataSheet = type === DOC_TYPE.DATASHEET;
    const isSelected = item.selected;

    return <NodeIcon
        isInMeeting={isInMeeting}
        isPagePublic={isPagePublic}
        isInTeam={isBook}
        isSheet={isSheet}
        isPPT={isPPT}
        isDataSheet={isDataSheet}
        isNotInheritRepo={isNotInheritRepo}
        isSelected={isSelected}
    />;
}

function getSwitcherIcon(item: any) {
    if (item.childCount === 0) {
        return null;
    }
    return (
        <div
            className={styles.treeSwitcherIcon}
            style={{
                backgroundImage: `url(${item.selected ? treeNodeArrowSelectedSvg : treeNodeArrowSvg})`,
                transform: `rotate(${item.expanded ? 90 : 0}deg)`,
            }}
        ></div>
    );
}

function getNewTreeData(treeData: any, parentKey: any, children: any) {
    const loop = (data: any) => {
        for (const item of data) {
            if (item.key === parentKey) {
                // eslint-disable-next-line no-param-reassign
                item.children = children;
                break;
            }
            if (item.children) {
                loop(item.children);
            }
        }
    };
    loop(treeData);
}

function SidebarTree(props: any) {
    const {
        slotHeader,
        slotFooter,
        repository = {},
        curDocuments,
        curDocument,
        sidebarLoad,
        onTreeLoad,
        documentOperate,
        docGuid,
        docsInMeeting,
        directoryEdit,
        commonDocRef,
        curNodeIsRoot,
        isTreeBatchOperate,
        externalRepoTips,
    } = props;
    const [status, setStatus] = useState({
        loading: false,
        error: false,
        notFound: false,
    });
    const intl = useIntl();
    const routerParam: {[key: string]: string} = useParams();
    const {spaceGuid, groupGuid, repositoryGuid} = routerParam;
    const history = useHistory();
    const [treeData, setTreeData] = useState<any>([]);
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
    const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
    const [height, setHeight] = useState(document.body.clientHeight - 58);
    const initDocGuidRef = useRef('');
    // 判断根节点是不是已经加载完成 根节点加载完成才能进行tree还原
    const [treeDataRootNodeIsLoad, setTreeDataRootNodeIsLoad] = useState(false);

    const [dragDialogVisible, setDragDialogVisible] = useState(false);
    const [dragData, setDragData] = useState();

    const treeRef = useRef<any>();
    const treeClickTimeId = useRef<any>();
    const loadingTimer = useRef<any>();
    const {docReady} = useRepositoryContext();
    const clickCommonDoc = useRef('');

    /**
     * 解决目录树数据同步问题：
     * curDocuments数据更新存在延迟/不更新的问题，导致目录树修改时出现异常
     * 将treeData同步到全局store，确保其他组件使用时能获取到最新数据
     * ！！！优先使用store中的treeData
     * 本次新增treeData用于解决目录树支持快速移动到顶部/底部需求
     */
    useEffect(() => {
        store.setTreeData(treeData);
    }, [treeData]);

    // 让某个节点滚动到屏幕中间位置
    function treeScrollTo(target: string | number) {
        const params = typeof target === 'number' ? target : {
            key: docGuid,
            offset: (window.innerHeight - 58) / 2 - 18,
        };
        treeRef.current?.scrollTo(params);
    }

    function isClickCommonDocScroll(target: string | number) {
        if (clickCommonDoc.current === 'commonDocClick') {
            clickCommonDoc.current = '';
        } else {
            treeScrollTo(target);
        }
    }

    function getTreeSelectedKeys() {
        return treeRef.current?.props?.selectedKeys || [];
    }

    function getTreeExpandedKeys() {
        return treeRef.current?.props?.expandedKeys || [];
    }

    function setTreeSelectedKeys(docGuids: string[]) {
        setSelectedKeys(docGuids);
    }

    function setTreeExpandKeys(docGuids: string[]) {
        const ids = docGuids.filter(item => !expandedKeys.includes(item));
        setExpandedKeys([...expandedKeys, ...ids]);
    }

    function findNodeByParent(parentGuid: string, {docGuid, name}: {docGuid?: string, name?: string}) {
        let nodes = [...treeData];
        let current = null;
        // eslint-disable-next-line no-cond-assign
        while (current = nodes.shift()) {
            if (current.parentGuid === parentGuid) {
                if ((docGuid && docGuid === current.docGuid) || (name && name === current.name)) {
                    return current;
                }
            }
            current.children && (nodes = nodes.concat(current.children));
        }
        return null;
    }

    useEffect(() => {
        const externalHeight = externalRepoTips ? 20 : 0;
        const onResize = () => setHeight(window.innerHeight - 58 - externalHeight);
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [externalRepoTips]);

    useEffect(() => {
        if (externalRepoTips) {
            setHeight(window.innerHeight - 58 - 20);
        } else {
            setHeight(window.innerHeight - 58);
        }
    }, [externalRepoTips]);

    const meetingNodesCache = useRef<string[]>([]);

    useEffect(() => {
        // 先把缓存的会议节点的状态全部设置为false
        const meetingDocGuids: string[] = docsInMeeting || [];
        const targetNodes = getNodesByIds(treeData, meetingDocGuids);
        const targetDocGuids = targetNodes.map(item => item.docGuid);

        if (!isSameArr(meetingNodesCache.current, targetDocGuids) && treeData.length > 0) {
            const closeNodes = getNodesByIds(treeData, meetingNodesCache.current);
            closeNodes?.forEach(item => {
                item.isMeeting = false;
            });
            const cache: any = [];
            targetNodes?.forEach(item => {
                cache.push(item.docGuid);
                item.isMeeting = true;
            });
            meetingNodesCache.current = cache;
            setTreeData([...treeData]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docsInMeeting, treeData]);

    const bookEditNodesCache = useRef<string[]>([]);

    useEffect(() => {
        // 先把缓存的知识本节点的状态全部设置为false
        const bookEditDocGuids: string[] = directoryEdit || [];
        const targetNodes = getNodesByIds(treeData, bookEditDocGuids, 'rootGuid');
        const targetDocGuids = targetNodes.map(item => item.docGuid);

        if (!isSameArr(bookEditNodesCache.current, targetDocGuids) && treeData.length > 0) {
            const closeNodes = getNodesByIds(treeData, bookEditNodesCache.current);
            closeNodes?.forEach(item => {
                item.canBookEdit = false;
            });
            const cache: any = [];
            targetNodes?.forEach(item => {
                cache.push(item.docGuid);
                item.canBookEdit = true;
            });
            bookEditNodesCache.current = cache;
            setTreeData([...treeData]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [directoryEdit, treeData]);

    useEffect(() => {
        if (docReady) {
            getBookDirData(repository);
            getDocsInMeeting();
        }
    }, [repository, docReady]);

    async function getChildrenList(docGuid: string) {
        const ksServer = await sdk.getKsServer(repository);
        const res = await ksServer.getDocumentsNew({
            parentGuid: docGuid || '',
        });
        return res;
    }

    async function loadData(treeNode?: any) {
        if (treeNode.children) {
            return Promise.resolve();
        }
        try {
            const ksServer = await sdk.getKsServer(repository);
            const res = await ksServer.getDocumentsNew({
                parentGuid: treeNode.docGuid || '',
            });
            if (!res) {
                return;
            }
            if (!treeNode?.docGuid) {
                store.setCurDocuments(res);
            }
            getTreeNodeListData(res, {spaceGuid, groupGuid});
            if (treeNode) {
                const data = [...treeData];
                getNewTreeData(data, treeNode?.docGuid, res);
                setTreeData(data);
            } else {
                setTreeData([...res]);
            }
        } catch (err) {
            console.error(err);
            toast({type: ToastType.Error, content: '目录获取失败，请重试'});
            throw err;
        }
    }

    function resetTree() {
        setSelectedKeys([]);
        setExpandedKeys([]);
        setTreeData([]);
        setStatus({...status, loading: false, error: false, notFound: false});
    }

    const curDocumentsRef = useRef(curDocuments);
    const treeDataLoadType = useRef('unknow');

    // 此方法为操作已存在数据并展开节点
    // 展开本节点及上层节点
    function expandNode(id: string, rel: string[] = []): any {
        const node = getNodeById(treeData, id);
        // 已经在根节点
        if (!node) {
            setExpandedKeys([...expandedKeys, ...rel]);
            return rel;
        }

        if (!expandedKeys.includes(id)) {
            rel.push(id);
        }
        return expandNode(node.parentGuid, rel);
    }

    // 此方法为加载数据并展开节点
    async function addChildNodesToRoot(
        parentId: string,
        docGuid: string,
        needScrollToNode = true
    ) {
        let childNodesData: any[] = [];
        let targetParentId = parentId;
        let targetId = docGuid;
        const needExpandedKeys = [];
        if (!repository) {
            return;
        }
        // 由于addChildNodesToRoot是在计时器里执行的导致了获取curDocuments时会因为闭包的问题无法及时更新
        // 使用这种方式保证获取的curDocuments为最新值
        curDocumentsRef.current = curDocuments;
        function findDoc(nodesData: any[], docGuid: string) {
            return nodesData.find(data => {
                return data.docGuid === docGuid;
            });
        }
        try {
            // 私密知识库下rootId可能不为0，增加some判断是否到根节点了
            while (targetParentId
                    // 如果当前节点的信息
                    // eslint-disable-next-line no-loop-func
                    && !curDocumentsRef.current?.some((item: any) => {
                        return item.parentGuid === targetParentId;
                    })
            ) {
                const lastChildNodes = childNodesData;
                childNodesData = await getChildNodesDataById(repository, targetParentId);
                const targetNode = lastChildNodes.length > 0 ? findDoc(childNodesData, targetId) : undefined;
                if (targetNode) {
                    targetNode.children = lastChildNodes;
                }
                const curDocumentGuId = curDocument
                    ? (curDocument.docGuid || '')
                    : '';
                const parentDoc = await getDocumentInfo(repository, targetParentId, curDocumentGuId);
                if (!parentDoc) {
                    break;
                }
                if (!parentDoc.parentGuid || !parentDoc.docGuid) {
                    throw (new Error('parentDoc 数据错误'));
                }
                !expandedKeys.includes(parentDoc.docGuid) && needExpandedKeys.push(parentDoc.docGuid);
                targetId = parentDoc.docGuid;
                targetParentId = parentDoc.parentGuid;
            }
        } catch (err) {
            childNodesData = [];
            console.error(err);
        }
        const rootParent = getNodeById(treeData, targetId);
        if (rootParent) {
            // 替换节点的时候如果原来有旧数据存在就不能重新渲染新的数据
            // 在这里重置一下根目录数据
            rootParent.children = childNodesData;
            // 定位完成并设置数据之后才能被认为左侧栏的tree第一次数据加载完毕
            treeDataLoadType.current = needScrollToNode ? 'addNodeToTree' : 'addNodeToTreeNoScroll';
            setTreeData([...treeData]);
            setExpandedKeys([...expandedKeys, ...needExpandedKeys.reverse()]);
        }
    }

    useEffect(() => {
        // 引起数据更新的几种情况
        // 1.新增节点并展开对应节点 => 第一次打开页面, 通过搜索或者常用页面访问不存在的节点
        // 2.展开对应节点
        if (treeDataLoadType.current === 'addNodeToTree' && !sidebarLoad) {
            onTreeLoad && onTreeLoad();
            treeDataLoadType.current = 'unknow';
        }
        if (sidebarLoad && treeDataLoadType.current === 'addNodeToTree') {
            setSelectedKeys(routerParam.docGuid ? [routerParam.docGuid] : []);
            setTimeout(() => {
                isClickCommonDocScroll(routerParam.docGuid);
            });
            treeDataLoadType.current = 'unknow';
        }
        if (sidebarLoad && treeDataLoadType.current === 'addNodeToTreeNoScroll') {
            setSelectedKeys(routerParam.docGuid ? [routerParam.docGuid] : []);
            treeDataLoadType.current = 'unknow';
        }
        store.setSidebarTreeObj({
            ...store.getSidebarTreeObj(),
            value: treeData,
            setValue: setTreeData,
            scrollTo: treeScrollTo,
            getSelectedKeys: getTreeSelectedKeys,
            getExpandedKeys: getTreeExpandedKeys,
            setSelectedKeys: setTreeSelectedKeys,
            setExpandedKeys: setTreeExpandKeys,
        });
        setTreeDataRootNodeIsLoad(treeData.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [treeData]);

    function clearLoadingTimer() {
        if (loadingTimer.current) {
            clearTimeout(loadingTimer.current);
            loadingTimer.current = null;
        }
    }

    useEffect(() => {
        return () => {
            store.setSidebarTreeObj({...store.getSidebarTreeObj(), value: []});
            clearLoadingTimer();
            // 组件销毁重置根目录
            store.setCurDocuments([]);
        };
    }, []);

    const isTocPage = window.isTocPage;
    async function refreshDocuments() {
        const privateNoPower = isPrivateAndNoPower();
        const restrictedAndNoPower = isRestrictedAndNoPower();
        // 对外toc环境下，受限知识库调用接口和私密知识库相同，内部环境下受限知识库调用正常接口（getDocuments）
        if (privateNoPower || (restrictedAndNoPower && window.isTocPage)) {
            try {
                if (!repository || isPersonalMyself(repository, sdk.user?.userGuid || '')) {
                    return;
                }
                loadingTimer.current = setTimeout(() => {
                    if (!status.loading) {
                        setStatus({...status, loading: true});
                    }
                    loadingTimer.current = null;
                }, 300);
                const result = await sdk.as.getPermissionDirList(repository.repositoryGuid || '');
                clearLoadingTimer();
                setStatus({...status, loading: false});
                if (isTocPage && result.length === 0) {
                    store.setCurRepositoryError(
                        new WizKnownError('无库权限', 10400, null, '10400')
                    );
                }
                return result;
            } catch (error) {
                clearLoadingTimer();
                setStatus({...status, loading: false});
                console.log(error);
            }
        }

        try {
            const docs = await getDocuments(repository);
            return docs;
        } catch (err) {
            console.error(err);
            toast({content: '目录获取失败，请刷新重试', type: ToastType.Error});
        }
    }

    useEffect(() => {
        // 根节点加载完成且首节点首次定位时才会发生滚动 且当前链接不是根目录链接
        if (sidebarLoad && !curNodeIsRoot) {
            let selectTarget = '';
            const isBaikeRoute = store.getData(store.KEYS.IS_BAIKE_ROUTE);
            if (!isBaikeRoute) {
                selectTarget = routerParam.docGuid || '';
            } else if (isBaikeRoute && routerParam.tagName) {
                const tagNameData = routerParam.tagName ? routerParam.tagName.split('·') : [];
                if (tagNameData[0] && tagNameData[1]) {
                    const node = findNodeByParent(tagNameData[0], {name: tagNameData[1]});
                    selectTarget = node?.docGuid || '';
                } else if (tagNameData[0]) {
                    selectTarget = tagNameData[0];
                }
            } else if (isBaikeRoute && routerParam.name) {
                const node = findNodeByParent(curDocument.parentGuid, {name: routerParam.name});
                selectTarget = node?.docGuid || '';
            }
            setSelectedKeys(selectTarget ? [selectTarget] : []);
            selectTarget && setTimeout(() => {
                treeScrollTo(selectTarget);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sidebarLoad]);

    useEffect(() => {
        function handelClickCommonDoc() {
            clickCommonDoc.current = 'commonDocClick';
        }
        const dom = commonDocRef && commonDocRef.current;
        dom && dom.addEventListener('click', handelClickCommonDoc);
        return () => {
            dom && dom.removeEventListener('click', handelClickCommonDoc);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sidebarLoad]);

    // repository 改变后加载 根页面列表数据
    useEffect(() => {
        // 个人知识库场景下：从主页跳转知识库文档页面，roleName从undefined -> 对应权限，导致重复resetTree
        if (isPersonalMyself(repository, sdk.user?.userGuid || '') && (
            !repository || !repository.repositoryGuid || !repository.roleName
        )) {
            return;
        }
        resetTree();
        store.setTreeLoaded(false);
        if (repository) {
            refreshDocuments().then((result: any) => {
                getTreeNodeListData(result, {spaceGuid, groupGuid});
                setTreeData(result);
                store.setCurDocuments(result);
                store.setTreeLoaded(true);

                if (isTocPage) {
                    // 对外场景下，能拿到文档列表，且当前不在文档详情页面，跳转到第一个文档详情页
                    if (result && result.length > 0 && !docGuid) {
                        const path = buildPath(routers.Knowledge.docPath, {
                            spaceGuid: repository.spaceGuid,
                            groupGuid: repository.groupGuid,
                            repositoryGuid: repository.repositoryGuid,
                            docGuid: result[0].docGuid,
                        });
                        history.push(path);
                    }
                }
                // setStatus({...status, loading: false, error: false, notFound: false});
                // 根目录加载完成且curDocument不存在的话就认为目录已经加载完成了
                if (!curDocument) {
                    onTreeLoad();
                }
            }).catch(err => {
                console.log(err);
                // setStatus({...status, loading: false, error: true, notFound: err?.errno === 404});
            });
        }
        // repository.roleName这个依赖不能删除
        // 从首页跳转到个人知识库首页的时候有三个地方设置了curRepository
        // 不能直接监听repository会导致点击标签等根目录节点的时候目录树重新刷新
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [repository.repositoryGuid, repository.roleName]);

    useEffect(() => {
        if (initDocGuidRef.current === curDocument?.docGuid) {
            return;
        }
        // 根节点加载之后展开节点
        // 展开的时机要延后避免影响到右侧文档的渲染
        // 已经加载过数据的时候不应该再触发
        if (curDocument && curDocuments && curDocuments.length > 0 && treeDataRootNodeIsLoad) {
            const docNode = getNodeById(treeData, curDocument.docGuid);
            if (sidebarLoad) {
                // 主要场景是常用标签点击需要还原目录
                if (docNode) {
                    expandNode(curDocument.parentGuid);
                    setTimeout(() => {
                        isClickCommonDocScroll(curDocument.docGuid);
                    });
                    setSelectedKeys(curDocument.docGuid ? [curDocument.docGuid] : []);
                } else {
                    addChildNodesToRoot(
                        curDocument.parentGuid || '',
                        curDocument.docGuid
                    );
                }
            } else if (docNode) {
                onTreeLoad();
            } else {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                // 展拉目录的时机往后放一放优先文档内容展示
                setTimeout(() => {
                    addChildNodesToRoot(
                        curDocument.parentGuid || '',
                        curDocument.docGuid
                    );
                });
            }
            initDocGuidRef.current = curDocument.docGuid;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curDocuments, curDocument, treeDataRootNodeIsLoad]);

    useEffect(() => {
        const isBaikeRoute = store.getData(store.KEYS.IS_BAIKE_ROUTE);
        if (isBaikeRoute) {
            // 百科页面时，如果没选中任何标签，则认为没选中目录树，选中的是最外层插槽中的List列表，需重置selectedKeys
            !routerParam.tagName && !routerParam.name && setSelectedKeys([]);
        } else {
            setSelectedKeys(routerParam.docGuid ? [routerParam.docGuid] : []);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, routerParam]);

    function handleLoad(keys: any) {
        console.log(keys, 'handleLoad------------');
    }

    function handleExpand(keys: any) {
        setExpandedKeys(keys);
    }

    const jumpProxy = kuPiper.runProxy(kuPiper.proxyNameMap.treeNodeClickJump, (node: any, e: any) => {
        if (e.metaKey || e.ctrlKey) {
            window.open(node.url);
        } else {
            history.push(node.url);
        }
    });

    function handleSelect(selectedKeys: any[], {selected, node, nativeEvent}: any) {
        const {key, isLeaf, url = ''} = node;
        if (selected) {
            setSelectedKeys([key]);
        }
        url && jumpProxy(node, nativeEvent);
        if (treeClickTimeId.current) {
            clearTimeout(treeClickTimeId.current);
            treeClickTimeId.current = undefined;
            return;
        }
        if (!isLeaf && !expandedKeys.includes(key)) {
            treeClickTimeId.current = setTimeout(() => {
                setExpandedKeys([...expandedKeys, key]);
                clearTimeout(treeClickTimeId.current);
                treeClickTimeId.current = undefined;
            }, 200);
        }
    }

    async function moveDocument({node: dropNode, dragNode, dropPosition}: any) {
        console.log('moveDocument-------');
        // 移动到的bookType为2或者3时，则是移动到知识本内
        const moveInBook = [BOOK_TYPE.IN_BOOK, BOOK_TYPE.IS_BOOK].includes(dropNode.bookType);
        const isInner = dropPosition === 0;

        const params = {
            toParentGuid: isInner ? dropNode.docGuid : (dropNode.parent?.node?.docGuid || ''),
            toRepoGuid: repository.repositoryGuid || '',
            docGuid: dragNode.docGuid,
            checkTime: Date.now() + '',
            sync: true,
            isKeepPermission: true,
            posDocGuid: isInner ? '' : dropNode.docGuid, // 基于哪个节点去定位
            isUpper: dropPosition === -1 ? true : dropPosition === 1 ? false : '', // 定位上方还是下方
        };
        try {
            const ksServer = await sdk.getKsServer(repository);
            const res = await ksServer.moveDocumentandRight(params);
            if (!res) {
                toast({content: '移动失败', type: ToastType.Error});
                return;
            }
            // 设置expandedKeys，删除和添加要一起操作
            const setExpanded = ({removeKey, addKey}: any) => {
                if (removeKey || addKey) {
                    const keys = removeKey ? expandedKeys.filter(item => item !== removeKey) : expandedKeys;
                    if (addKey && !keys.includes(addKey)) {
                        keys.push(addKey);
                    }
                    setExpandedKeys(keys);
                }
            };
            const newNodeData = getTreeNodeData({...res}, {spaceGuid, groupGuid}); // res要用新对象，下面还用到原值
            const newNode = {
                ...newNodeData,
                children: dragNode.children,
                isMeeting: dragNode.isMeeting,
                canBookEdit: dragNode.canBookEdit,
            };
            // 删除节点
            const parentIsLeaf = delTreeNodeByDrag(treeData, dragNode); // 返回删除拖拽节点后，原父节点是否是叶子节点
            // 添加节点
            addTreeNodeByDrag(treeData, newNode, dropNode, dropPosition);
            setTreeData([...treeData]);
            setExpanded({
                removeKey: parentIsLeaf ? dragNode.parentGuid : null,
                addKey: isInner && !dropNode.expanded ? dropNode.docGuid : null,
            });

            setTimeout(() => {
                const docUpdateData: DocumentUpdateData = {
                    action: DocumentOperateType.Move,
                    parentGuid: params.toParentGuid,
                };
                const docData: WizDocument = Object.assign(docUpdateData, {
                    docGuid: dragNode.docGuid,
                    spaceGuid: repository.spaceGuid || '',
                    groupGuid: repository.groupGuid || '',
                    repositoryGuid: repository.repositoryGuid || '',
                });
                if (res.docGuid === curDocument?.docGuid) {
                    store.setCurDocument({...curDocument, ...res});
                }
                // 通过store更新拖拽后位置的父级目录
                store.setDocumentOperate({
                    docList: [docData],
                    type: DocumentOperateType.Update,
                    updateType: docUpdateData.action,
                });
            }, 0);
            let toastSuccessContent = '移动成功';
            if (moveInBook) {
                const ksServer = await sdk.getKsServer(repository);
                // 获取知识本剩余公开时间，如果大于0则弹指定文案
                const res = await ksServer.getPublicTimeliness({docGuid: dropNode.rootGuid});
                toastSuccessContent = res > 0 ? '文档移入到知识本后，公开时效与知识本保持一致' : '移动成功';
            }
            toast({content: toastSuccessContent, type: ToastType.Success});
            feLogger(docMove({
                kb_org_id: repository?.groupGuid,
                kb_id: repository?.repositoryGuid,
                page_id: dragNode.docGuid,
            }));
        } catch (error) {
            if (+error.code === 16002) {
                toast({
                    content: <span>无法拖动，此处页面已被删除，
                        <a onClick={() => window.location.reload()}>立即刷新</a>
                        <Icon
                            svg={CloseSvg}
                            size={IconSize.XS}
                            onClick={() => toastObjects[ToastType.Warning]?.remove()}
                            style={{marginLeft: 8, verticalAlign: 'baseline'}}
                        />
                    </span>,
                    type: ToastType.Warning,
                    duration: -1,
                });
            } else if (+error.code === 16003) {
                toast({content: '移动失败，上级文档中已存在知识本', type: ToastType.Error});
            } else {
                toast({content: '移动失败', type: ToastType.Error});
            }
        }
    }

    function dragErrorToast(message: string) {
        toast({content: message, type: ToastType.Error});
    }

    function handleDrop(data: any) {
        console.log(data, 'handleDrop---------');
        const {node: dropNode, dragNode, dropPosition} = data;
        const startIsBook = dragNode.bookType === BOOK_TYPE.IS_BOOK;
        const startInBook = dragNode.bookType === BOOK_TYPE.IN_BOOK && dragNode.rootGuid;
        const startNoBook = dragNode.bookType === BOOK_TYPE.NO_BOOK;
        const endIsBook = dropNode.bookType === BOOK_TYPE.IS_BOOK;
        const endInBook = dropNode.bookType === BOOK_TYPE.IN_BOOK && dropNode.rootGuid;
        const endNoBook = dropNode.bookType === BOOK_TYPE.NO_BOOK;
        const startRootGuid = dragNode.rootGuid;
        const endRootGuid = dropNode.rootGuid;
        const canDocEdit = dragNode.docRoleName === 'DocAdmin' || dragNode.docRoleName === 'DocMember';
        const {settings: {newGuide}} = sdk.as.user as User;
        const isInner = dropPosition === 0;
        const {isAdmin, isMember} = KuAuthority.getAuthRepository();

        if (isAdmin) {
            if (startNoBook && (endIsBook && isInner || endInBook)) {
                if (newGuide?.moveInBook) {
                    moveDocument(data);
                    return;
                }
                setDragData({...data, moveType: 'docToDir', rootGuid: endRootGuid, rootName: dropNode.rootName});
                setDragDialogVisible(true);
                return;
            } else if (startInBook && (endNoBook || endIsBook && !isInner)) {
                if (newGuide?.moveOutBook) {
                    moveDocument(data);
                    return;
                }
                setDragData({...data, moveType: 'dirToDoc', rootGuid: startRootGuid, rootName: dragNode.rootName});
                setDragDialogVisible(true);
                return;
            } else if (startInBook && (endIsBook && isInner || endInBook) && startRootGuid !== endRootGuid) {
                if (newGuide?.moveInBook) {
                    moveDocument(data);
                    return;
                }
                setDragData({...data, moveType: 'dirToDir', rootGuid: endRootGuid, rootName: dropNode.rootName});
                setDragDialogVisible(true);
                return;
            }
        } else if (isMember) {
            if (startNoBook && (endIsBook && isInner || endInBook)) {
                dragErrorToast(intl.formatMessage({id: 'moveError'}));
                return;
            }
            if (startInBook && (endNoBook ||
                (endIsBook && !isInner) ||
                (endInBook && startRootGuid !== endRootGuid) ||
                (endIsBook && isInner && startRootGuid !== endRootGuid)
            )) {
                dragErrorToast(intl.formatMessage({id: 'moveError'}));
                return;
            }
        } else {
            if ((!canDocEdit && startInBook) || startNoBook || startIsBook) {
                dragErrorToast('无当前知识库移动权限');
                return;
            }
            if (startInBook && endInBook && startRootGuid !== endRootGuid) {
                dragErrorToast('无当前知识库移动权限');
                return;
            }
            if (startInBook && (endNoBook ||
                (endIsBook && !isInner) ||
                (endIsBook && isInner && startRootGuid !== endRootGuid)
            )) {
                dragErrorToast(intl.formatMessage({id: 'moveError'}));
                return;
            }
        }
        moveDocument(data);
    }

    function renderNodeContent(node: any) {
        return (
            <CustomNode node={node} />
        );
    }

    // 设置侧边栏置顶的tab样式
    const setSidebarToTop = (target?: HTMLDivElement) => {
        const indexDom: HTMLDivElement | null = document.querySelector('.sidebar-document-index');
        const QACenterDom: HTMLDivElement | null = document.querySelector('.sidebar-qa-center');
        const targetDom = target || document.querySelector('.sidebar-tree-wrap .rc-tree-list-holder');
        if (!targetDom || (!indexDom && !QACenterDom)) {
            return;
        }
        // 有目录，没有智能问答/有智能问答，没有目录，保持原有逻辑
        if ((indexDom && !QACenterDom) || (!indexDom && QACenterDom)) {
            const currentDom = indexDom || QACenterDom;
            const indexOffset = currentDom?.offsetTop || 0;
            const scrollTop = targetDom.scrollTop;
            currentDom?.classList.remove('tree-node-item-top-two-container');
            // 留了1pxbuffer  不然在节点定位的时候会出问题
            if (scrollTop - indexOffset >= -1) {
                currentDom?.setAttribute('data-topNum', 'one');
                currentDom?.classList.add('tree-node-item-top-one-container');
            } else {
                currentDom?.setAttribute('data-topNum', 'none');
                currentDom?.classList.remove('tree-node-item-top-one-container');
            }
        }
        // 有目录，且有智能问答中心，调整两个tab的top值
        if (indexDom && QACenterDom) {
            const scrollTop = targetDom.scrollTop;
            const indexOffset = indexDom.offsetTop;
            const QACenterOffset = QACenterDom.offsetTop;
            // 留了1pxbuffer  不然在节点定位的时候会出问题
            if (scrollTop - QACenterOffset >= -1) {
                QACenterDom.setAttribute('data-topNum', 'one');
                QACenterDom.classList.add('tree-node-item-top-one-container');
            } else {
                QACenterDom.setAttribute('data-topNum', 'none');
                QACenterDom.classList.remove('tree-node-item-top-one-container');
            }
            // 留了1pxbuffer  不然在节点定位的时候会出问题
            if (scrollTop - indexOffset >= -53) {
                indexDom.setAttribute('data-topNum', 'two');
                indexDom.classList.add('tree-node-item-top-two-container');
            } else {
                indexDom.setAttribute('data-topNum', 'none');
                indexDom.classList.remove('tree-node-item-top-two-container');
            }
        }
    };

    const handleTreeScroll = (event: any) => {
        setSidebarToTop(event.target);
    };

    useEffect(() => {
        setSidebarToTop();
    }, [slotHeader]);

    function renderIndicator({dropPosition, dropLevelOffset, indent}: any) {
        if (dropPosition === 0 && dropLevelOffset === 0) { // 正中间
            return null;
        }
        const style: React.CSSProperties = {};
        let className = '';
        switch (dropPosition) {
            case -1: // top
                className = 'indicatorTop';
                style.top = -1;
                style.left = 0;
                break;
            case 1: // bottom
                className = 'indicatorBottom';
                style.bottom = -1;
                style.left = indent;
                break;
            case 0: // inner
                className = 'indicatorBottomInner';
                style.bottom = -1;
                style.left = indent;
                break;
        }
        return (
            <div className={classNames(styles.indicator, styles[className])} style={style} />
        );
    }

    // 用户操作页面后，更新树
    useEffect(() => {
        function resetOperate() {
            // 执行完成相关操作应该把值置为空
            // 不然一些依赖这个状态的组件在更新的时候会炸
            store.setDocumentOperate({
                docList: [],
                docGuidList: [],
                type: '',
                updateType: '',
            });
        }
        if (!repository || !documentOperate) {
            resetOperate();
            return;
        }
        // 当操作列表为空时不执行操作
        const {docList = [], docGuidList = []} = documentOperate;
        if (docList.length === 0 && docGuidList.length === 0) {
            return;
        }

        const parentNodes = new Map<string, TreeNodeData | null>();

        function updateChildNodesOfParent() {
            const rel: any = [];
            if (!repository) {
                return Promise.all(rel);
            }
            Array.from(parentNodes.values()).forEach(node => {
                treeDataLoadType.current = 'createNode';
                rel.push(updateChildNodes(
                    repository,
                    node ? node.docGuid as string : ''
                ));
            });
            return Promise.all(rel);
        }

        // 找到需要跳转的页面的 docGuid
        function findDocGuid(parentNode: TreeNodeData, curNode: TreeNodeData, withDescendants: boolean) {
            const docId: string = '';
            if (!curNode) {
                return docId;
            }
            // 删除父文档、但不删除子文档时，退回第一个子文档
            if (!withDescendants && curNode.children) {
                const firstNode = curNode.children[0];
                return firstNode ? (firstNode.docGuid || '') : '';
            }
            if (!withDescendants && curNode.childCount && curNode.childCount > 0 && !curNode.children) {
                // 当前节点子节点还未加载
                return '';
            }
            // 如果找不到父节点则表示在根节点
            const parentChildren = parentNode ? parentNode.children : treeData;
            const nextNode = getNextNode(curNode.docGuid, parentChildren);
            const preNode = getPreNode(curNode.docGuid, parentChildren);
            if (nextNode) {
                // 上一个节点存在
                return nextNode.docGuid || '';
            } else if (preNode) {
                // 下一个节点存在
                return preNode.docGuid || '';
            }

            if (parentNode) {
                // 父节点
                return parentNode.docGuid || '';
            }
        }

        async function deleteDoc(itemGuid: string, data: any) {
            const {
                value: treeData,
                setValue: setTreeData,
            } = store.getSidebarTreeObj();
            if (!repository) {
                return;
            }
            const curDocNode = getNodeById(treeData, itemGuid);
            if (!curDocNode) {
                return;
            }
            // 父元素不存在则表示当前被删的元素在根节点
            const curDocParentNode = getNodeById(treeData, curDocNode.parentGuid);
            // 跳转逻辑
            // 有两种情况一种是被删除的元素子元素已经加载一种是被删除子元素有子节点但是还没加载
            let docId = findDocGuid(curDocParentNode, curDocNode, data.withDescendants);
            const newTreeData = await updateChildNodesAfterDel(
                repository,
                curDocParentNode ? curDocParentNode : {children: treeData},
                curDocNode
            );
            // 有子元素但是docId为空说明之前获取docId的时候子节点还没加载
            if (!docId && curDocNode.childCount > 0) {
                // 子元素会拼接到父元素的末尾
                const newParent = getNodeById(newTreeData, curDocNode.parentGuid);
                const parentChildren = newParent ? newParent.children : newTreeData;
                const oldFirstNode: any = parentChildren[parentChildren.length - 1 - (curDocNode.childCount - 1)];
                docId = oldFirstNode && oldFirstNode.docGuid;
            }
            const url = buildPath(routers.Knowledge.path, {
                spaceGuid, groupGuid, repositoryGuid,
                docGuid: docId || '',
            });
            setTimeout(() => {
                const jumpProxy = kuPiper.runProxy(kuPiper.proxyNameMap.deleteDocUrlJump, (url: string) => {
                    history.push(url);
                });
                jumpProxy(url, curDocNode.docGuid);
            });
        }

        if (
            (documentOperate.type === DocumentOperateType.Create
            || documentOperate.type === DocumentOperateType.Recovery)
            && documentOperate.docList
        ) {
            // 创建节点需要定位节点到视图中间
            clickCommonDoc.current = '';
            documentOperate.docList.forEach((doc: any) => {
                if (!doc.docGuid || !doc.parentGuid) {
                    return;
                }
                // 找不到parentNode则将目标节点添加到根节点
                const parentNode = getNodeById(treeData, doc.parentGuid);
                if (parentNode) {
                    parentNodes.set(doc.parentGuid, parentNode);
                } else {
                    parentNodes.set(doc.parentGuid, null);
                }
            });
            updateChildNodesOfParent().then(() => {
                const parentNodesKeys = Array.from(parentNodes.keys());
                setExpandedKeys(Array.from(new Set([...expandedKeys, ...parentNodesKeys])));
                if (!documentOperate.data) {
                    return;
                }
                const {url, openInNewTab, type} = documentOperate.data;
                if (openInNewTab) {
                    return;
                }
                if (type === DOC_TYPE.DIRECTORY) {
                    setTimeout(() => {
                        history.push({
                            pathname: url,
                            state: {
                                isNew: true,
                                isEdit: true,
                            },
                        });
                    }, 0);
                    return;
                }

                if (url) {
                    const jumpProxy = kuPiper.runProxy(kuPiper.proxyNameMap.createDocUrlJump,
                        (openInNewTab: boolean, url: string) => {
                            history.push({
                                pathname: url,
                                search: '',
                                state: {
                                    isNew: true,
                                    isEdit: true,
                                },
                            });
                        });
                        // setTimeout保证跳转逻辑在treeStore.map数据更新之后执行
                    setTimeout(() => {
                        jumpProxy(openInNewTab, url, type);
                    }, 0);
                }
            });
        }

        if (documentOperate.type === DocumentOperateType.Delete) {
            if (documentOperate.docGuidList) {
                documentOperate.docGuidList.forEach((itemGuid: any) => {
                    // 此刻执行的时机为接口请求完成
                    // 因此只需要更新一下父元素就行
                    deleteDoc(itemGuid, documentOperate.data);
                });
            }
        }

        if (documentOperate.type === DocumentOperateType.Update) {
            if (documentOperate.docList && documentOperate.updateType) {
                const isAcross = documentOperate.updateType === DocumentOperateType.Across;
                const isCopyAndMove = [DocumentOperateType.Copy, DocumentOperateType.Move].includes(
                    documentOperate.updateType
                );
                const isPublish = documentOperate.updateType === DocumentOperateType.Publish
                    || documentOperate.updateType === DocumentOperateType.Rename;
                const isPagePublic = documentOperate.updateType === DocumentOperateType.Knowledge;
                const isBookInherit = documentOperate.updateType === DocumentOperateType.Inherit;
                const isActiveChange = documentOperate.updateType === DocumentOperateType.Active;
                documentOperate.docList.forEach((doc: any) => {
                    if (!doc.docGuid) {
                        return;
                    }
                    if (isAcross) {
                        // 移动或者删除文档之后需要把store里的对应展开的ExpandedId删掉防止状态不对
                        // 这种情况下需要重新从server拉数据所以放弃了原本的展开状态
                        // 之后遇到了小箭头状态不对的情况下可以来这里扒一扒
                        // deleteExpandedIdsFromNode(doc.docGuid);
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        // deleteDoc(doc.docGuid);
                        // 移动文档之后更新curDocuments
                        // refreshDocuments();
                        const curNode = getNodeById(treeData, doc.docGuid);
                        if (curNode) {
                            const parentNode = getNodeById(treeData, curNode.parentGuid);
                            updateChildNodes(repository, parentNode ? parentNode.docGuid : '', {
                                treeData: treeData,
                                setTreeData: setTreeData,
                            });
                        }
                    }
                    if (isPagePublic) {
                        const node = getNodeById(treeData, doc.docGuid);
                        if (!node) {
                            return;
                        }
                        const isBook = node.type === DOC_TYPE.DIRECTORY;
                        // 知识本设置公开状态的时候需要连子元素一起设上
                        const allChildNode = isBook ? getPosterityNodes(node) : [];
                        allChildNode.push(node);
                        allChildNode && allChildNode.forEach(item => {
                            if (doc.operation === DocumentUpdateOperation.Add) {
                                item.scope = PageScope.PagePublic;
                            } else if (doc.operation === DocumentUpdateOperation.Delete) {
                                item.scope = PageScope.pageClosed;
                            } else if (doc.operation === DocumentUpdateOperation.Update) {
                                item.scope = doc.permission || PageScope.PagePublic;
                            }
                        });
                        setTreeData([...treeData]);
                    }
                    if (isCopyAndMove) {
                        const node = getNodeById(treeData, doc.docGuid);
                        if (!node) {
                            return;
                        }
                        const privateNoPower = isPrivateAndNoPower();
                        if (privateNoPower && (curDocument?.type === DOC_TYPE.DIRECTORY && !doc.isFromQuickMove)) {
                            return;
                        }
                        const parentNode = getNodeById(treeData, node.parentGuid);
                        updateChildNodes(repository, parentNode ? parentNode.docGuid : '', {
                            treeData: treeData,
                            setTreeData: setTreeData,
                        });
                        return;
                    }
                    if (isPublish) {
                        const node = getNodeById(treeData, doc.docGuid);
                        if (!node) {
                            return;
                        }
                        const name = doc.name;
                        node.name = name;
                        setTreeData([...treeData]);
                        if (doc.docGuid === docGuid) {
                            setDocumentTitle(name, intl);
                        }
                    }
                    // 这里是为了判断目录菜单里的常用页面的状态
                    if (isActiveChange) {
                        const node = getNodeById(treeData, doc.docGuid);
                        if (!node) {
                            return;
                        }
                        node.active = doc.active;
                        setTreeData([...treeData]);
                    }
                    if (isBookInherit) {
                        const node = getNodeById(treeData, doc.docGuid);
                        if (!node) {
                            return;
                        }
                        node.inheritRepo =
                            !node.inheritRepo || node.inheritRepo === InheritRepo.Inherit
                                ? InheritRepo.Not_Inherit : InheritRepo.Inherit;
                        setTreeData([...treeData]);
                    }
                });
            }
        }
        resetOperate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentOperate]);

    const handleTreeClick = useCallback(e => {
        if (isMac()) {
            // mac下command被按下
            e.metaKey && e.stopPropagation();
        } else {
            e.ctrlKey && e.stopPropagation();
        }
    }, []);

    function handleTreeRef(ref: HTMLDivElement) {
        if (ref) {
            // 当按住command或者win下按住ctrl时默认的click功能应该禁止
            ref.removeEventListener('click', handleTreeClick);
            ref.addEventListener('click', handleTreeClick);
        }
    }

    // 批量操作
    const batchOperateProps = useTreeBatchOperate();
    return (
        <div
            className={classNames(styles.treeWrap, 'sidebar-tree-wrap')}
            ref={handleTreeRef}
        >
            <Tree
                ref={treeRef}
                className={classNames(!status.loading && styles.treeNotLoading)}
                onScroll={handleTreeScroll}
                treeData={treeData}
                height={height}
                itemHeight={36}
                icon={getIcon}
                virtual
                draggable
                switcherIcon={getSwitcherIcon}
                loadData={loadData}
                titleRender={renderNodeContent}
                expandedKeys={expandedKeys}
                selectedKeys={selectedKeys}
                slotHeader={slotHeader}
                slotFooter={slotFooter}
                bufferHeight={180}
                dropIndicatorRender={renderIndicator}
                expandAction={false}
                onLoad={handleLoad}
                onExpand={handleExpand}
                onSelect={handleSelect}
                onDrop={handleDrop}
                {...batchOperateProps}
            />
            {
                status.loading && isPrivateAndNoPower() ? (
                    <div className={styles.loading}>
                        <Icon svg={LoadSvg} />
                        <span className={styles.loadingText}>加载中...</span>
                    </div>
                ) : null
            }
            <SidebarAddMenu />
            <SidebarMoreMenu />
            <SidebarDragDialog
                visible={dragDialogVisible}
                dragData={dragData}
                onCancel={() => setDragDialogVisible(false)}
                onConfirm={(data: any) => {
                    setDragDialogVisible(false);
                    moveDocument(data);
                }}
            />
            {<BatchTool repository={repository} isTreeBatchOperate={isTreeBatchOperate} docGuid={docGuid} />}
        </div>
    );
}

export default store.connect([
    store.KEYS.DOCS_IN_MEETING,
    store.KEYS.DIRECTORY_EDIT,
    store.KEYS.IS_TREE_BATCH_OPERATE,
    store.KEYS.TREE_SELECTED_OBJ,
    store.KEYS.TREE_SELECTED_FULL,
    store.KEYS.EXTERNAL_REPO_TIPS,
])(SidebarTree);
